import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";

/** The software-factory seats' tools, kept out of the big canonical map so it
 * stays under the line cap. */
export const factoryToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.SUBMIT_SPECS, () => labelOnly("Submitted the specs")],
  [HOST_TOOL_NAMES.SET_BRAND_KIT, () => labelOnly("Set the brand kit")],
  [HOST_TOOL_NAMES.PLAN_TICKETS, () => labelOnly("Planned the tickets")],
  [
    HOST_TOOL_NAMES.MARK_PROVISIONING_STEP,
    (record) => {
      const name = toolInput.trimmed(record.name);
      const status = toolInput.trimmed(record.status);
      return labelOnly(
        name && status
          ? `Marked provisioning step ${name} ${status}`
          : "Reported a provisioning step",
      );
    },
  ],
  [HOST_TOOL_NAMES.DECIDE_MERGE, () => labelOnly("Settled the ticket's PR")],
  [HOST_TOOL_NAMES.DECIDE_QA, () => labelOnly("Settled the QA verdict")],
];
